import type { ChatInputEntityData } from '@fluentui-copilot/chat-input-plugins';
import type { ChatInputEntityProps } from '../../ChatInputEntity';

export type ChatInputEntityPluginRef<ExtraDataType = undefined> = {
  // Inserts a new entity and returns its key, to be used by removeChatInputEntity or updateChatInputEntityProps
  insertChatInputEntity: (props: ChatInputEntityData<ExtraDataType, ChatInputEntityProps>) => string | undefined;
  // Removes an entity by its key, or removes all entities that match a predicate function
  removeChatInputEntity: (
    keyOrPredicate: string | ((entity: ChatInputEntityData<ExtraDataType, ChatInputEntityProps>, i: number) => boolean),
  ) => void;
  // Updates an entity by its key, or removes all entities that match a predicate function
  updateChatInputEntityProps: (
    keyOrPredicate: string | ((entity: ChatInputEntityData<ExtraDataType, ChatInputEntityProps>, i: number) => boolean),
    props:
      | ChatInputEntityData<ExtraDataType, ChatInputEntityProps>
      | ((
          oldProps: ChatInputEntityData<ExtraDataType, ChatInputEntityProps>,
        ) => ChatInputEntityData<ExtraDataType, ChatInputEntityProps>),
  ) => void;
  getActiveEntities: () => ChatInputEntityData<ExtraDataType, ChatInputEntityProps>[];
};
